import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { SpinnerComponent } from './spinner.component';

@Injectable({ providedIn: 'root' })
export class SpinnerService {

  private overlayRef: OverlayRef = null;
  constructor(private overlay: Overlay) { }

  public show(isOverlay = true) {
    // Returns an OverlayRef (which is a PortalHost)

    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create();
    }

    // Create ComponentPortal that can be attached to a PortalHost
    const spinnerOverlayPortal = new ComponentPortal(SpinnerComponent);

    if (!this.overlayRef.hasAttached()) {
      // run in async context for triggering "tick", thus avoid ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        const component = this.overlayRef.attach(spinnerOverlayPortal); // Attach ComponentPortal to PortalHost
        component.instance.isOverlay = isOverlay;

      });
    }
  }

  public hide() {
    setTimeout(() => {
      if (!!this.overlayRef) {
        this.overlayRef.detach();
      }
    }, 250);
  }
}
